import htmx from "htmx.org"

// Domain status polling. Uses htmx.onLoad so it re-arms on hx-boost swaps
// (e.g. navigating into a settings page from the navbar).
htmx.onLoad(function(content) {
  const siteIdElement = content.querySelector('[data-site-id]');
  if (!siteIdElement) return;

  const siteId = siteIdElement.dataset.siteId;
  const statusUrl = siteIdElement.dataset.statusUrl;
  let pollInterval = null;

  function checkForPendingDomains() {
    const badges = document.querySelectorAll('.domain-status-badge .badge.bg-warning');
    return badges.length > 0;
  }

  function updateDomainStatus() {
    fetch(statusUrl)
      .then(response => response.json())
      .then(data => {
        if (data.domains) {
          data.domains.forEach(domain => {
            updateDomainUI(domain);
          });

          // Stop polling if no pending domains
          if (!checkForPendingDomains()) {
            stopPolling();
          }
        }
      })
      .catch(error => {
        console.error('Error fetching domain status:', error);
      });
  }

  function updateDomainUI(domain) {
    const badge = document.querySelector(`.domain-status-badge[data-domain-id="${domain.id}"]`);
    const info = document.querySelector(`.domain-status-info[data-domain-id="${domain.id}"]`);

    if (!badge || !info) return;

    // Update badge
    let badgeHTML = '';
    if (domain.status === 'active') {
      badgeHTML = '<span class="badge bg-success">Active</span>';
    } else if (domain.status === 'failed') {
      badgeHTML = '<span class="badge bg-danger">Failed</span>';
    } else {
      badgeHTML = '<span class="badge bg-warning">Pending</span>';
    }
    badge.innerHTML = badgeHTML;

    // Update status info with server-rendered HTML
    info.innerHTML = domain.status_html || '';
  }

  function startPolling() {
    if (!pollInterval) {
      pollInterval = setInterval(updateDomainStatus, 30000); // Poll every 30 seconds
    }
  }

  function stopPolling() {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  }

  // Start polling if there are pending domains
  if (checkForPendingDomains()) {
    startPolling();
  }

  // Stop polling when page is hidden
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      stopPolling();
    } else if (checkForPendingDomains()) {
      startPolling();
    }
  });

  // Handle verify domain button clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('.verify-domain-btn')) {
      const button = e.target.closest('.verify-domain-btn');
      const domainId = button.dataset.domainId;
      const domainName = button.dataset.domainName;

      // Disable button and show loading state
      button.disabled = true;
      const originalHTML = button.innerHTML;
      button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Verifying...';

      // Trigger verification
      fetch(`/domains/verify/${domainId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Update UI with new status
          updateDomainUI(data.domain);

          // Show success message
          if (data.domain.status === 'active') {
            // Hide the verify button since domain is now active
            button.style.display = 'none';

            // Show success notification
            _.alert(`<i class="bi bi-check-circle"></i> <strong>${domainName}</strong> verified successfully!`, 'success');
          } else {
            // Re-enable button if verification failed
            button.disabled = false;
            button.innerHTML = originalHTML;

            // Show failure message
            _.alert(`Verification failed: ${data.message}`, 'warning');
          }
        } else {
          throw new Error(data.error || 'Verification failed');
        }
      })
      .catch(error => {
        console.error('Error verifying domain:', error);
        button.disabled = false;
        button.innerHTML = originalHTML;
        _.alert('Error verifying domain. Please try again.', 'danger');
      });
    }
  });
});
